import { Card } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { InlineFallbackContents } from "../../../../../shared/components/errors/InlineErrorBoundary"
import { PropsWithChildren } from "react"

const useStyles = makeStyles()(() => ({
    card: {
        flex: 1,
        borderRadius: ".5rem",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        maxHeight: "14rem",
    },
}))

type CardFallbackProps = PropsWithChildren<{
    icon?: JSX.Element
    errorMessage?: string
    classNames?: string
    contentClassNames?: string
}>

export function UserDashboardErrorFallbackCard({
    icon,
    errorMessage,
    classNames,
    children,
    contentClassNames,
}: CardFallbackProps) {
    const { classes } = useStyles()

    return (
        <Card className={(classes.card, classNames)}>
            {children}
            <InlineFallbackContents icon={icon} externalClasses={contentClassNames} errorMessage={errorMessage} />
        </Card>
    )
}
